//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import md5 from 'js-md5'
// import store from '@/store'                    // 引入vuex数据
import UsreProtocol from './user-protocol'

export default {
  name: 'register',
  components: {
    UsreProtocol
  },
  data () {
    return {
      alertBol: false,
      showType: 'register',
      phone: '',     // 手机号码
      password: '',  // 密码
      rpassword: '',
      canPush: false, // 是否通过校验
      verifTip: this.$t('userCenter.loginPage.txt17'),
      canGetVerifCode: false, // 能否获取验证码
      timeInterval: 60,  // 验证码获取cd
      graphInfo: { // 图形验证信息
        graphCode: '',
        graphCodeKey: '',
        graphUrl: ''
      },
      protocolType: 'profile',   // profile 协议  privateInfo 隐私政策
      canRegister: false,
      inputGraphCode: '', // 用户输入的图形验证码
      smscode: '' // 短信验证码
    }
  },
  mounted () {
    // this.$t('userCenter.loginPage.txt17'),
    // this.$_message(12)
    console.log(this.$t('userCenter.loginPage.txt17'), '22')
    this.getGraphCode()
  },
  methods: {
    // 验证空值
    validate (...params) {
      let temp = true
      params.forEach(element => {
        if (!element) {
          temp = false
        }
      })
      return temp
    },
    close () {
      this.$emit('close')
    },
    btn () {
      // if (this.canGetVerifCode)
      if (this.rpassword !== this.password) {
        this.$_message(this.$t('flowLogin66'))
        return
      }
      if (!this.validate(this.password, this.phone, this.smscode)) return
      let data = {
        'password': md5(this.password),
        'phone': this.phone,
        'smscode': this.smscode
      }
      this.$api.post('USER_REGISTER', data, (res) => {
        this.close()
      })
    },
    // 获取验证码
    getVerifCode () {
      if (this.timeInterval < 60  || !this.canGetVerifCode) return
      this.verifTip = `${this.$t('flowLogin83')}${this.timeInterval}${this.$i18n.locale === 'en' ? 'S' : this.$t('flowLogin12')}`
      this.canGetVerifCode = false
      let data = {
        'business': 1,
        'graphCodeKey': this.graphInfo.graphCodeKey,
        'graphcode': this.inputGraphCode,
        'phone': this.phone
      }
      this.$api.post('USER_GETSMSCODE', data, (res) => {
        if (res.code === 0) {
          let timer = setInterval(() => {
            if (this.timeInterval > 1) {
              this.timeInterval--
              this.verifTip = `${this.$t('flowLogin83')}${this.timeInterval}${this.$i18n.locale === 'en' ? 'S' : this.$t('flowLogin12')}`
            } else {
              clearInterval(timer)
              this.timeInterval = 60
              this.canGetVerifCode = true
              this.verifTip = this.$t('userCenter.loginPage.txt17')
            }
          }, 1000)
          if (this.phone.indexOf('@') > -1) {
            this.alertBol = true
          }
        } else {
          this.timeInterval = 60
          this.canGetVerifCode = true
          this.verifTip = this.$t('userCenter.loginPage.txt17')
          this.getGraphCode()
        }
      }, () => {})
    },
    // 获取图形验证码
    getGraphCode () {
      this.$api.post('USER_GRAPHCODE', '', (res) => {
        this.graphInfo = {...res.data}
        this.inputGraphCode = ''
      })
    },
    showProtocol (type) {
      this.protocolType = type
      this.showType = 'protocol'
    },
    showRegister () {
      this.showType = 'register'
    }
  },
  watch: {
    phone (val) {
      this.canGetVerifCode = this.validate(this.phone, this.inputGraphCode)
      this.canRegister = this.validate(this.password, this.phone, this.smscode)
    },
    inputGraphCode (val) {
      this.canGetVerifCode = this.validate(this.phone, this.inputGraphCode)
    },
    smscode () {
      this.canRegister = this.validate(this.password, this.phone, this.smscode)
    },
    password () {
      this.canRegister = this.validate(this.password, this.phone, this.smscode)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSimpleLogin/src/register.vue